/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: utils\validators.ts
 🗓️ Created: 2026-05-02
 🧩 Description:
    Implementation of the PBX Class of Services module.
────────────────────────────────────────────────────────────────*/


import type { FormState } from '../types';

export interface ValidationErrors {
  [key: string]: string;
}

export function validateCustomerCodeForm(
  formData: FormState,
  domainId: number | null | undefined,
  t: (key: string) => string
): ValidationErrors {
  const errors: ValidationErrors = {};

  if (!domainId) {
    errors.domainId = t('customerCodes.messages.domainMissing');
  }

  if (!formData.code.trim()) {
    errors.code = t('customerCodes.fields.code.required');
  }

  return errors;
}

